import React from 'react';

import { Serving } from '@/components/AccountPanel/components/Serving';
import { IndexIndicator } from '@/components/shared/IndexIndicator';
import { UserMilestones } from '@/config/constants';
import { Permissions } from '@/graphql';
import { classNames } from '@/helpers/classNames';
import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';
import { useAuth } from '@/providers/AuthProvider';
import { usePermissions } from '@/providers/PermissionsProvider';

import { OnboardingContext } from './Onboarding';
import styles from './Onboarding.module.scss';

const StepThree = () => {
	const { updateUser } = useAuth();
	const { setStep, step, canUpdateTeam, shouldAddService, completedStepIndices } =
		React.useContext(OnboardingContext);
	const fireSaveServing = useAnalyticsEvent('Onboarding_Step3_Save_Serving');
	const fireSkipToInfographic = useAnalyticsEvent('Onboarding_Step3_Skip_To_Infographic');

	return (
		<Serving
			hasBack
			actionLabel={canUpdateTeam ? 'Next' : 'Done'}
			bottomActionProps={{
				className: styles['layout'],
				contentClassName: styles['step-three'],
				topContent: (
					<IndexIndicator
						className={styles['indicator']}
						dotClassName={styles['dot']}
						total={canUpdateTeam ? 6 : 2}
						current={1}
						variant="stretched"
						onIndicatorClick={(i) => setStep(i + 2)}
						hasHover
						conditionalItems={[
							{ index: 3, visible: shouldAddService },
						]}
						disabledItems={[{ index: 5, enabled: false }]}
					hasDataItems={completedStepIndices}
					/>
				),
			}}
			onBack={() => {
				setStep(step - 1);
			}}
			onSave={() => {
				if (!canUpdateTeam) {
					fireSkipToInfographic();
					updateUser({
						input: {
							completedMilestones: [
								UserMilestones.PROFILE_SET_UP,
							],
						},
					});
					setStep(8); // jump to final infographic step
				} else {
					fireSaveServing();
					setStep(4);
				}
			}}
			leadingContent={
				<div className={styles['title-header']}>
					<div className={styles['heading']}>How you serve</div>
					<div className={classNames([styles['text'], 'mt-sm'])}>
						This helps organize your team.
					</div>
				</div>
			}
		/>
	);
};

export default StepThree;
